// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { baseGridHiddenProps, baseGridProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useMemo } from "react";

export interface SideColumnLayoutProps extends ExpandStyles<SideColumnLayoutStyles> {
    id: string;
    showSideColumnOnMobile?: boolean;
    // Store Custom Code
    showSideColumnOnRight?: boolean;
}

export interface SideColumnLayoutStyles {
    container?: GridContainerProps;
    leftColumn?: GridItemProps;
    rightColumn?: GridItemProps;
}

export const sideColumnLayoutStyles: SideColumnLayoutStyles = {};

const SideColumnLayout: FC<SideColumnLayoutProps> = ({
    id,
    extendedStyles,
    overridedStyles,
    showSideColumnOnMobile,
    // Store Custom Code
    showSideColumnOnRight,
}) => {
    const baseStyles = useMemo(() => {
        const gridProps = showSideColumnOnMobile ? baseGridProps : baseGridHiddenProps;
        return mergeProps<SideColumnLayoutStyles>(sideColumnLayoutStyles, {
            container: gridProps.container,
            leftColumn: gridProps.sideColumn,
            rightColumn: gridProps.mainColumn,
        });
    }, [sideColumnLayoutStyles, showSideColumnOnMobile]);
    const styles = useExpandProps(baseStyles, extendedStyles, overridedStyles);

    /* Store Custom Code - Start */
    const sideColumn = (
        <GridItem {...styles.leftColumn}>
            <Zone contentId={id} zoneName="Side" />
        </GridItem>
    );
    /* Store Custom Code - End */

    return (
        <GridContainer {...styles.container}>
            {/* Store Custom Code - Start */}
            {!showSideColumnOnRight && sideColumn}
            {/* Store Custom Code - End */}
            <GridItem {...styles.rightColumn}>
                <Zone contentId={id} zoneName="Content" />
            </GridItem>
            {/* Store Custom Code - Start */}
            {showSideColumnOnRight && sideColumn}
            {/* Store Custom Code - End */}
        </GridContainer>
    );
};

export default SideColumnLayout;
